<nx-pageTitle-box class="mb-3" [label]="'Labels'" [icon]="'icon-bookmark'" [iconToolTip]="'Labels'"
  [bcRootLvlLabel]="'Einstellungen'"
  [bcRootLvlPath]="'settings'">
</nx-pageTitle-box>

<nx-table-header
  label="Labelliste">
  <ng-template nxTemplate="end">
    <input
      pInputText
      type="text"
      (input)="filterByText($event.target?.['value'])"
      class="p-inputtext p-component p-element mr-3"
      placeholder="Label suchen" />
    <nx-command-button
      [reloadable]="this"
      [style]="'light'"
      [commandName]="'labelCreateCommand'"
      [icon]="'icon-plus'">
    </nx-command-button>
  </ng-template>
</nx-table-header>


<p-table
  [lazy]="true"
  [value]="labels"
  [scrollable]="true"
  [paginator]="true"
  [rows]="15"
  [rowsPerPageOptions]="[15, 20, 50]"
  [totalRecords]="totalElements"
  [loading]="loading"
  (onPage)="onPageChange($event)"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {last} von {totalRecords}">
<ng-template pTemplate="caption">
    <div class="flex flex-row">
      <div class="basis-2/3 flex flex-row gap-2">

      </div>
      <div class="basis-1/3 flex flex-row justify-end">
        <p-dropdown
          placeholder="Sortierung"
          [styleClass]="'sort'"
          appendTo="body"
          [ngModel] = "sortModel"
          [options]="sortOptions | translateLabels"
          optionLabel="label"
          [showClear]="false"
          (onChange)="sort($event)">
        </p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="white-space:nowrap;">Label</th>
      <th style="width:100%;">Beschreibung</th>
      <th style="white-space:nowrap;"></th>
    </tr>
    </ng-template>
    <ng-template pTemplate="body" let-label>
      <tr >
        <td style="white-space:nowrap;"><app-label [label]="label"></app-label></td>
        <td style="width:100%;">{{label.description ? label.description : '-'}}</td>
        <td style="white-space:nowrap;" class="text-right">
          <nx-default-button
            [style]="'dark'"
            class="mr-2"
            (click)=editLabel(label)
            [icon]="'icon-edit'"
            [tooltip]="'Bearbeiten'">
          </nx-default-button>
          <nx-default-button
            [style]="'dark'"
            (click)=deleteLabel(label)
            [icon]="'icon-trash'"
            [tooltip]="'Löschen'">
          </nx-default-button>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="emptyMessage">Keine Labels vorhanden.</td>
      </tr>
    </ng-template>
</p-table>
